import React, { ReactElement } from 'react';
import classNames from 'classnames';
import PricingCardsV2 from '@components/shared/PrincingCardsV2/PricingCardsV2';
import { PACKAGES } from '@components/shared/PrincingCardsV2/common';
import { useRouter } from 'next/router';
import useGetStartedCtaLink from '@hooks/useGetStartedCtaLink/useGetStartedCtaLink';
import styles from './Packages.module.scss';

interface IPackages {
  className?: string;
  merch?: boolean;
  cards?: ReactElement;
  cardsClassName?: string;
}

const Packages = ({
  className = '',
  cardsClassName = '',
  merch,
  cards,
}: IPackages) => {
  const router = useRouter();
  const link = useGetStartedCtaLink();

  const handleCTA = (pkg: PACKAGES) => {
    if (pkg === PACKAGES.AT_HOME) {
      return router.push('/in-person');
    }
    if (merch) {
      let giftQuery = 'ONLINE';
      if (pkg === PACKAGES.MERCH) {
        giftQuery = 'MERCH_ONLY';
      }
      return router.push(`/gift/checkout?gift=${giftQuery}`);
    }
    return router.push(link);
  };

  return (
    <section
      id="packages-section"
      className={classNames(
        styles.Container,
        className,
        styles.isNewHomePage
      )}
    >
      <PricingCardsV2 CTA={handleCTA} cards={cards} className={cardsClassName} />
    </section>
  );
};

export default Packages;
